<template>
    <transition name="el-zoom-in-top">
  
    <!--verification-screen v-if="!showDialog" :user="this.user"/-->

        <div class="content-wrapper">
            <!-- Content Header (Page header) -->
            <section class="content-header">
               
            </section>
            <!-- Main content -->
            <section class="content" >
                <el-dialog title="Sign Up" customClass="customWidth" :show-close="false" :visible.sync="dialogVisible" size="tiny" visible="false"   >
                    <div class="account-box">
                      

                        <form role="form">
                            <!--TODO: move to styles class and the display errors inline with their respective fields -->
                             <div ref="errorDiv" v-if="this.errorList.length > 0"  class="form-group">
                                 <b style="font-size:9pt; color:red;">Please correct the following error(s):</b><br>
                          <br> <ul ><li style="color: red;
 font-size: 7pt;
font: times-new-roman;
font-weight:bold;
 margin-top: -2%;
 padding: 3pt;
 text-align:auto;" v-for='error in this.errorList'>{{error}}</li></ul></div>
                            <div class="form-group"> <a href="#" class="pull-right label-forgot"></a>
                                <label  for="inputFirstname">First Name<span style="content:'*';color:red;"> *</span></label>
                                <input type="text" id="inputUsernameEmail"  class="form-control required control-label:after" v-model="user.firstName" required> </div>
                            <div class="form-group"> <a href="#" class="pull-right label-forgot"></a>
                                <label for="inputLastname">Last Name<span style="content:'*';color:red;"> *</span></label>
                                <input type="text" id="inputUsernameEmail" class="form-control" v-model="user.lastName" required> </div>                                 
                            <div class="form-group"> <a href="#" class="pull-right label-forgot"></a>
                                <label for="inputEmail">Email Address<span style="content:'*';color:red;"> *</span></label>
                                <input type="text" id="inputUsernameEmail" class="form-control" v-model="user.email" required> </div>
                            <div class="form-group"> <a href="#" class="pull-right label-forgot"></a>
                                <label for="inputPhone">Phone<span style="content:'*';color:red;"> *</span></label>
                                <vue-phone-number-input v-model="user.phone" /> </div>
                            <div class="form-group"> <a href="#" class="pull-right label-forgot"></a>
                                <label for="inputUsername">Username<span style="content:'*';color:red;"> *</span></label>
                                <input type="text" id="inputUsernameEmail" class="form-control" v-model="user.username" required> </div>
                            <div class="form-group"> <a href="#" class="pull-right label-forgot"></a>
                                <label for="inputPassword">Password<span style="content:'*';color:red;"> *</span></label>
                                <input style="margin-bottom:-10px;"  type="password" id="inputPassword" class="form-control" v-model="user.password" required> </div>
                                <!-- An element to toggle between password visibility -->
<input  style="margin-bottom:20px;font-size:9pt;" type="checkbox" v-on:click="showPassword('inputPassword')"><small>Show Password</small>
                            <div class="form-group"> <a href="#" class="pull-right label-forgot"></a>
                                <label  for="inputConfirmPassword">Confirm Password<span style="content:'*';color:red;"> *</span></label>
                                <input  style="margin-bottom:-10px;"type="password" id="inputConfirmPassword" class="form-control" v-model="user.confirmPassword" required> </div>
                                <!-- An element to toggle between password visibility -->
                        <input style="margin-bottom:20px;font-size:9pt;" type="checkbox"  v-on:click="showPassword('inputConfirmPassword')"><small>Show Password</small>
                            <div class="form-group"> <a href="#" class="pull-right label-forgot"></a>
                                <label  for="inputZipcode">Zipcode<span style="content:'*';color:red;"> *</span></label>
                                <input type="text" id="inputZipcode" class="form-control" v-model="user.zipcode" required> </div>
                            <div class="form-group"> <a href="#" class="pull-right label-forgot"></a>
                                <label for="inputCity">City</label>
                                <input type="text" id="inputCity" class="form-control" v-model="user.city"> </div>
                            <div class="form-group"> <a href="#" class="pull-right label-forgot"></a>
                                <label for="inputState">State</label>
                                <input type="text" id="inputState" class="form-control" v-model="user.state"> </div>
                        </form>
                        <a class="forgotLnk" href="#"></a>
                        <!--<div class="or-box">
                            <center><span class="text-center login-with">Login or <b>Sign Up</b></span></center>
                            <div class="row">
                                <div class="col-md-6 row-block">
                                    <a href="#" class="btn btn-facebook btn-block"> <span class="ti-facebook space-icon"></span>Facebook</a>
                                </div>
                                <div class="col-md-6 row-block">
                                    <a href="#" class="btn btn-twitter btn-block"> <span class="ti-twitter space-icon"></span>Twitter</a>
                                </div>
                            </div>
                            <div style="margin-top:25px" class="row">
                                <div class="col-md-6 row-block"> <a href="#/profile" class="btn btn-google btn-block"><span class="ti-google space-icon"></span>Google +</a> </div>
                                <div class="col-md-6 row-block"> <a href="#" class="btn btn-instagram btn-block"><span class="ti-instagram space-icon"></span>Instagram</a> </div>
                            </div>
                        </div> -->
                        <hr>
                        <div class="row-block">
                            <div class="row">
                                 <center><span  class="text-center login-with customFont">Already have an account? <b><a href="#/login">Login</a></b></span></center>

                                <div class="col-md-12 row-block"> <a href="#" class="btn btn-primary btn-block" v-on:click="registerClick">Register Account</a> </div>
                            </div>
                        </div>
                    </div>
                </el-dialog>
            </section>
            <!-- /.content -->
        </div>
    </transition>
</template>
<script>
import VerificationScreen from './VerificationScreen.vue'
//import * as Firebase  from "firebase";
import emailValidator from 'pragmatic-email-regex'
const { v4: uuidv4 } = require('uuid');
import 'vue-phone-number-input/dist/vue-phone-number-input.css';
const db = require('../services/database/database')
const cliStorage = require('../services/libraries/clientStoragelib')
const cliStorNames = cliStorage.clientStorageNames
  const commonDB = require('../services/database/common')

  export default {
  components: { VerificationScreen },
    data: function () {
      return {
        dialogVisible: false,
        showDialog: true,
        userToken: "",
        user:{
         firstName : '',
         lastName: '',
        phone : '',
        email: '',
        username: '',
        password: '',
        confirmPassword: '',
        city: '',
        zipcode: '',
        state: '',
        userID : ''},
              errorList: []

      }
          },
    methods: {
        gotoLogin: function(){
this.$router.push('/login')
        },
      handleClose: function () {
        this.$confirm('Are you sure that you want to exit and lose all data?', 'Warning', {
          confirmButtonText: 'OK',
          cancelButtonText: 'Cancel',
          type: 'warning'
        }).then(this.gotoLogin).then(function () {
    console.log("close screen.")
  }).catch(function (err) {
        console.log("canceled." + err)

  })
      },
      showPassword: function (inputId) {
  var x = document.getElementById(inputId);
  if (x.type === "password") {
    x.type = "text";
  } else {
    x.type = "password";
  }
},
       goto: function(refName) {
        var element = this.$refs[refName];
        console.log(element);
        this.$nextTick(() => {
            element.scrollIntoView()
        });
        // var top = element.offsetTop;
        // window.scrollTo(0, top);
    },
      registerClick: async function(){
          
          this.errorList = []
          let isEmailValid = emailValidator(this.user.email)
           if (!this.user.firstName){
              this.errorList.push('First name cannot be empty')
          }
           if (!this.user.lastName){
              this.errorList.push('Last name cannot be empty')
          }
           if (!this.user.email){
              this.errorList.push('Email cannot be empty')
          }
           if (!this.user.phone){
              this.errorList.push('Phone number cannot be empty')
          }
          if (!this.user.username){
              this.errorList.push('Username cannot be empty')
          }
           if (!this.user.password){
              this.errorList.push('Password cannot be empty')
          }
           if (!this.user.confirmPassword){
              this.errorList.push('Confirm password cannot be empty')
          }
           if (!this.user.zipcode){
              this.errorList.push('Zipcode cannot be empty')
          }
          if (!isEmailValid){
              this.errorList.push('Invalid Email Address')
          }
          if(this.user.password !== this.user.confirmPassword){
              this.errorList.push("Passwords don't match")
          }
          
        if(this.errorList.length === 0){
            console.log("signing up user")
            var Auth = require('../services/Authentication/auth')
        var to = require('await-to-js').default
       //Sign up user
        const userData = this.user
          console.log(userData)
          let result,error;
         [error, result] = await to(Auth.SignUpUser(userData))
        
        if (error){
            console.log("error signing up user", error.response)
        const errorMsg = error.response.data.error.message 
        this.$confirm("Error: " + errorMsg, 'Signup Error', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancel'
      })
        }

        else if (result){
            console.log("successful signing up user!", result)
            this.$store.commit('setUserAuthentication', true)
            //create user credentials to navigate them to the home page after verification
             this.$cookie.set(cliStorNames.USER_TOKEN.name,result.data.idToken)
             this.userToken = result.data.idToken
        //delete user passwords after auth sign up
        delete this.user.password
        delete this.user.confirmPassword
        this.user.userID = result.data.idToken
        const localID = result.data.localId
        
  //add user to firestore DB
  //NOTE: USE CAMELCASE, NO SPECIAL CHARS WHEN ADDING FIELDS TO DB!! FIRESTORE DB DOESNT LIKE IT
   
        let dbErr, dbRes;
      [dbErr, dbRes] = await to(commonDB.addUserToDb(this.userToken, this.user.firstName, this.user.lastName, this.user.phone,this.user.email, this.user.zipcode, this.user.city,this.user.state,
      this.user.username, uuidv4().toString(),localID, Date.now().toString()))
       if (dbErr){
        console.error(dbErr)
        throw dbErr
    }
    else if(dbRes){
        console.log("User added to DB!", dbRes)
    }

    //We have to create subcollections for the users collection once a new user has been added to DB
    //--------------------------------------------------------------------------------------------------------------------
    let accidentDbErr, accidentDbRes;
      [accidentDbErr, accidentDbRes] = await to(commonDB.addAccidentToDb(this.userToken, localID, "", "", "", "", "", "","", "", "", "", "", "", "PlaceHolder", []))
       if (accidentDbErr){
        console.error(accidentDbErr)
        throw accidentDbErr
    }
    else if(accidentDbRes){
        console.log("accident added to DB!", accidentDbRes)
    }
    const accountId = localID
    let documentPath = "users/" + accountId.toString() + "/accidents/PlaceHolder"
    let accidentDelErr, accidentDelRes;
    [accidentDelErr, accidentDelRes] = await to(db.deleteDocument(this.userToken, documentPath))
    if (accidentDelErr){
        console.error(accidentDelErr)
    }
    console.log(accidentDelRes)
    let policyDbErr, policyDbRes;
      [policyDbErr, policyDbRes] = await to(commonDB.addPolicyToDb(this.userToken, localID,"", "PlaceHolder", "", "", "", "", "", "", "", []))
       if (policyDbErr){
        console.error(policyDbErr)
        throw policyDbErr
    }
    else if(policyDbRes){
        console.log("Policy added to DB!", policyDbRes)
    }
    documentPath = "users/" + accountId.toString() + "/policies/PlaceHolder"
    let policyDelErr, policyDelRes;
    [policyDelErr, policyDelRes] = await to(db.deleteDocument(this.userToken, documentPath))
    if (policyDelErr){
        console.error(policyDelErr)
    }
    console.log(policyDelRes)
    //-------------------------------------------------------------------------------------------------------------------------

        this.$router.push({name: 'verification', params: {user:this.user }})
        }

        }
        else{
            this.goto('errorDiv')
           
        }

        
        //   var Auth = require( "../../services/authentication")
        //var Firebase = require('firebase')
        //console.log("fire", Firebase)
//         // var fb = require('../../firebase/config')
//         const firebaseConfig = {
//     apiKey: "AIzaSyB8gJVdOWUTN6AsXQdBoexq-TD8JUWnEI4",
//     authDomain: "fir-app-db494.firebaseapp.com",
//     databaseURL: "https://fir-app-db494-default-rtdb.firebaseio.com",
//     projectId: "fir-app-db494",
//     storageBucket: "fir-app-db494.appspot.com",
//     messagingSenderId: "12700357190",
//     appId: "1:12700357190:web:4479819483393296b8f047",
//     measurementId: "G-YCCCR3NDVT"
//   };

    // fire.initializeApp(firebaseConfig);
    // fire
    //         .auth()
    //         .createUserWithEmailAndPassword("something", "nothing")
        
        //}
    //     .then((result)=>
    //     {
    //     console.log(result)
    //     this.$router.push('/')
    //     this.showDialog = false

    //     }).catch((error) =>{
    //         console.log(error.data)
    //     const errorMsg = error.data.error.message 
    //     if (errorMsg === 'INVALID_EMAIL'){
    //         console.error(errorMsg)
    //         alert("Invalid Email Format.")
    //     }
    //        // console.log("firebase", fire)

    //       //const [result, error] = Auth.onRegisterPress(userData)

    //     //   if (result){
    //     //       alert("Registration successful! Welcome!")
    //     //   }
    //     //   else{
            
    //     //   }
    //   })
      
      },
      log: function(item){
          console.log(item)
          return true
      }}

  }
</script>
<style scoped>
/* .collapsible {
  background-color: #777;
  color: white;
  cursor: pointer;
  padding: 18px;
  width: 100%;
  border: none;
  text-align: left;
  outline: none;
  font-size: 15px;
}

.active, .collapsible:hover {
  background-color: #555;
} */
.required .control-label:after {
  content:"*";color:red;
}
.error-content {
color: red;
 font-size: 9pt; 
 padding-top: -40px;
 
}
@media(max-width:450px){
  
.customFont{
        font-size: 10pt;
        
    }
}
.customWidth{
        width:90%;
        
    }
@media(min-width:450px){
  
.customFont{
        font-size: 15pt;
        
    }
  
}


</style>



// WEBPACK FOOTER //
// SignUp.vue?60b7d9da